import React, {useState} from 'react';
import './style.scss'
import {Tab, Tabs} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import TakingOrderNew from "./TakingOrderNew";
import TakingOrderPreparing from "./TakingOrderPreparing";
import TakingOrderDelivery from "./TakingOrderDelivery";
import TakingOrderClosed from "./TakingOrderClosed";

function TakingOrder() {
  const {t} = useTranslation();
  const [activeTab, setActiveTab] = useState("1");

  return (
    <>
      <div className="tab-section">
        <Tabs
          activeKey={activeTab}
          transition={false}
          className="panel_tab"
          onSelect={(e) => setActiveTab(e)}
        >
          <Tab
            eventKey="1"
            className="panel_tab_item"
            title={t("Organizational.Restaurant.TakingOrder.New.Tab")}
          >
          </Tab>
          <Tab
            eventKey="2"
            className="panel_tab_item"
            title={t("Organizational.Restaurant.TakingOrder.Preparing.Tab")}
          >
          </Tab>
          <Tab
            eventKey="3"
            className="panel_tab_item"
            title={t("Organizational.Restaurant.TakingOrder.Delivery.Tab")}
          >
          </Tab>
          <Tab
            eventKey="4"
            className="panel_tab_item"
            title={t("Organizational.Restaurant.TakingOrder.Closed.Tab")}
          >
          </Tab>
        </Tabs>
        <div className="content-section">
          {activeTab === "1" && <TakingOrderNew/>}
          {activeTab === "2" && <TakingOrderPreparing/>}
          {activeTab === "3" && <TakingOrderDelivery/>}
          {activeTab === "4" && <TakingOrderClosed/>}
        </div>
      </div>
    </>
  );
}

export default TakingOrder;
